import { numberToPercentageString } from './number-to-percentage-string';

const numberToPercentageStringWithLimits = (value: number): string => {
  if (value < 0) return '<0%';
  if (value > 100) return '>100%';

  if (value === 0) return '0.00%';
  if (value === 100) return '100.00%';
  if (value < 0.01) return '<0.01%';
  if (value > 99.99) return '>99.99%';

  return numberToPercentageString(value, {
    accuracy: 2,
    noMultiply: true,
  });
};

export default numberToPercentageStringWithLimits;
